import React from 'react';

import { Button } from 'hosman-material';

const IndepRecrutement = () => {
  return (
    <a href='https://hosman-agent-launchpad.lovable.app' target='_blank' data-testid='IndepRecrutement' className='md:w-[500px]'>
      <div className='flex flex-col gap-8 text-ih-indigo border-2 border-ih-purple-20 hover:border-ih-purple-40 bg-hosman-gradient-1 rounded-3xl p-5'>
        <div className='flex flex-col gap-2 text-ih-indigo text-center'>
          <p className='h3'>Envie de rejoindre Hosman en tant qu'agent immobilier indépendant ?</p>
          <p className='h2'>Nous recrutons !</p>
        </div>

        <img src='https://res.cloudinary.com/vesta-home/image/upload/v1731927395/assets/images/static_pages/Photo-2.webp' className='w-[350px] object-cover object-center aspect-[4/3] mx-auto rounded-2xl' />

        <div className='md:w-max mx-auto'>
          <Button label='Postuler !' />
        </div>
      </div>
    </a>
  );
}

export default IndepRecrutement;
